import React from 'react'
import PropTypes from 'prop-types';

/**
 * 
 * @param {*} showKeyOnly 
 * @param {*} _key 
 * @returns 
 */
export default function Language(props) {
    return (
        <span className=' flex space-x-1 py-1 px-2 bg-blue-50 text-blue-500 border font-semibold border-blue-500 border-dashed text-[8pt] rounded uppercase'>
            # {props.showKeyOnly ? getLanguageKey_(props._key).toUpperCase() : getLanguageKey(props._key)}
        </span>
    )
}


const getLanguageKey = (languageKey) => {
    let languageList = {
        'ar': "arabic",
        'fr': "french",
        'en': "english",
        'drj': "arabic_dialect_ma",
        "ar_ma":"arabic_dialect_ma",
        'arabic_dialect_ma': "arabic_dialect_ma",
        'arabic': "arabic",
        'french': "french",
        'english': "english",
        "darija":"arabic_ma",
        'default': null
    };
    return (languageList[languageKey] || languageList['default']);
}


const getLanguageKey_ = (languageKey) => {
    let languageList = {
        'ar': "AR",
        'fr': "FR",
        'en': "EN",
        'drj':"AR_MA",
        "ar_ma":"AR_MA",
        'arabic_dialect_ma': "AR_MA",
        'arabic': "Ar",
        'french': "FR",
        'english': "EN",
        'default': null
    };
    return (languageList[languageKey] || languageList['default']);
}

Language.propTypes = {
  showKeyOnly: PropTypes.bool,
  _key: PropTypes.string,
};
